// @flow
import * as React from 'react'
import styled from 'styled-components'

import ZoomControl from './ZoomControl'

// This is a very bad solution and I'm sorry
const ZoomWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 1.5rem;
  width: 15%;
`

function ResponseZoomControl(): React.Node {
  return (
    <ZoomWrapper>
      <ZoomControl />
    </ZoomWrapper>
  )
}

export default ResponseZoomControl
